
import EmpresasPage from './pages/empresas';
import BandejaComponent from './pages/bandeja';
import ComponentPdf from './pages/exportpdf'


export const GET_USERS_API = 'users/';
export const GET_USER_API = 'users/2';
export const PATH_API = 'https://reqres.in/api/';
export const COLLECTION_USER_NAME = 'users'; 
export const paths = [
    { path: '/empresas', component: EmpresasPage },
    { path: '/bandeja', component: BandejaComponent },
    { path: '/exportpdf', component: ComponentPdf },
];



export const main = EmpresasPage;